import lang from '../../../lib/language';
import { ETF_SECTOR_NAME } from '../../../lib/services/fundamental/helpers';
import { SectorEnum } from '../../../lib/store/fundamental/types';

import BasicMaterials from '../../../assets/popularGroupsLogos/BasicMaterials.png';
import BasicMaterialsShort from '../../../assets/popularGroupsLogos/BasicMaterials_short.png';
import Communications from '../../../assets/popularGroupsLogos/Communications.png';
import CommunicationsShort from '../../../assets/popularGroupsLogos/Communications_short.png';
import ConsumerDiscretionary from '../../../assets/popularGroupsLogos/ConsumerDiscretionary.png';
import ConsumerDiscretionaryShort from '../../../assets/popularGroupsLogos/ConsumerDiscretionary_short.png';
import ConsumerStaples from '../../../assets/popularGroupsLogos/ConsumerStaples.png';
import ConsumerStaplesShort from '../../../assets/popularGroupsLogos/ConsumerStaples_short.png';
import Energy from '../../../assets/popularGroupsLogos/Energy.png';
import EnergyShort from '../../../assets/popularGroupsLogos/Energy_short.png';
import ETFs from '../../../assets/popularGroupsLogos/ETFs.png';
import ETFsShort from '../../../assets/popularGroupsLogos/ETFs_short.png';
import FinancialServices from '../../../assets/popularGroupsLogos/FinancialServices.png';
import FinancialServicesShort from '../../../assets/popularGroupsLogos/FinancialServices_short.png';
import Healthcare from '../../../assets/popularGroupsLogos/Healthcare.png';
import HealthcareShort from '../../../assets/popularGroupsLogos/Healthcare_short.png';
import Industrials from '../../../assets/popularGroupsLogos/Industrials.png';
import IndustrialsShort from '../../../assets/popularGroupsLogos/Industrials_short.png';
import RealEstate from '../../../assets/popularGroupsLogos/RealEstate.png';
import RealEstateShort from '../../../assets/popularGroupsLogos/RealEstate_short.png';
import Technology from '../../../assets/popularGroupsLogos/Technology.png';
import TechnologyShort from '../../../assets/popularGroupsLogos/Technology_short.png';
import Utilities from '../../../assets/popularGroupsLogos/Utilities.png';
import UtilitiesShort from '../../../assets/popularGroupsLogos/Utilities_short.png';

const groups = {
  Technology: {
    logo: Technology,
    shortLogo: TechnologyShort,
    name: lang.popularGroupTechnology(),
    sectorName: SectorEnum.Technology,
  },
  CommunicationServices: {
    logo: Communications,
    shortLogo: CommunicationsShort,
    name: lang.popularGroupCommunications(),
    sectorName: SectorEnum.CommunicationsServices,
  },
  HealthCare: {
    logo: Healthcare,
    shortLogo: HealthcareShort,
    name: lang.popularGroupHealthcare(),
    sectorName: SectorEnum.HealthCare,
  },
  Energy: {
    logo: Energy,
    shortLogo: EnergyShort,
    name: lang.popularGroupEnergy(),
    sectorName: SectorEnum.Energy,
  },
  ConsumerStaples: {
    logo: ConsumerStaples,
    shortLogo: ConsumerStaplesShort,
    name: lang.popularGroupConsumerStaples(),
    sectorName: SectorEnum.ConsumerStaples,
  },
  Materials: {
    logo: BasicMaterials,
    shortLogo: BasicMaterialsShort,
    name: lang.popularGroupBasicMaterials(),
    sectorName: SectorEnum.Materials,
  },
  Industrials: {
    logo: Industrials,
    shortLogo: IndustrialsShort,
    name: lang.popularGroupIndustrials(),
    sectorName: SectorEnum.Industrials,
  },
  Financials: {
    logo: FinancialServices,
    shortLogo: FinancialServicesShort,
    name: lang.popularGroupFinancialServices(),
    sectorName: SectorEnum.Financials,
  },
  RealEstate: {
    logo: RealEstate,
    shortLogo: RealEstateShort,
    name: lang.popularGroupRealEstate(),
    sectorName: SectorEnum.RealEstate,
  },
  ConsumerDiscretionary: {
    logo: ConsumerDiscretionary,
    shortLogo: ConsumerDiscretionaryShort,
    name: lang.popularGroupConsumerDiscretionary(),
    sectorName: SectorEnum.ConsumerDiscretionary,
  },
  Utilities: {
    logo: Utilities,
    shortLogo: UtilitiesShort,
    name: lang.popularGroupUtilities(),
    sectorName: SectorEnum.Utilities,
  },
  ETFs: {
    logo: ETFs,
    shortLogo: ETFsShort,
    name: lang.popularGroupETFs(),
    sectorName: ETF_SECTOR_NAME,
  },
};

export default groups;
